// La notification du système à la fin d'un passage : l'analyse prend
// plusieurs minutes, l'utilisateur est parti ailleurs. Elle ne part qu'avec
// l'accord du navigateur, demandé une seule fois depuis la carte de veille,
// et seulement si l'onglet n'est pas sous les yeux.

import { t } from "@shared/client/locale";

export type PassOutcomeNotice = {
  newLeads: number;
  reactivated: number;
  sample: Array<{ name: string; isNew: boolean }>;
};

export function notificationsSupported() {
  return typeof window !== "undefined" && "Notification" in window;
}

function describe({ ok, outcome, offerName }: { ok: boolean; outcome: PassOutcomeNotice | null; offerName: string | null }) {
  const copy = t().shell.passNotification;
  if (!ok) return { title: copy.interrupted(offerName), body: copy.interruptedBody };
  if (!outcome || outcome.newLeads + outcome.reactivated === 0) {
    return { title: copy.completed(offerName), body: copy.nothingNewBody };
  }
  const title =
    outcome.newLeads > 0 ? copy.newLeads(outcome.newLeads, offerName) : copy.reactivated(outcome.reactivated, offerName);
  const names = outcome.sample.map((item) => item.name);
  const shown = names.slice(0, 2).join(", ");
  const rest = outcome.newLeads + outcome.reactivated - Math.min(names.length, 2);
  const body = [
    shown && copy.names(shown, rest),
    outcome.newLeads > 0 && outcome.reactivated > 0 ? copy.alsoReactivated(outcome.reactivated) : null,
  ]
    .filter(Boolean)
    .join(" ");
  return { title, body };
}

export function notifyPassEnded(
  pass: { ok: boolean; outcome: PassOutcomeNotice | null; offerName: string | null },
  onOpen: () => void,
) {
  if (!notificationsSupported() || Notification.permission !== "granted") return;
  if (document.visibilityState === "visible" && document.hasFocus()) return;
  const { title, body } = describe(pass);
  try {
    const notification = new Notification(title, { body, icon: "/icon.png", tag: "hune-pass" });
    notification.onclick = () => {
      window.focus();
      onOpen();
      notification.close();
    };
  } catch {
    // Certains navigateurs mobiles exigent un service worker : on s'en passe.
  }
}
